export function setupFullscreenPanelObserver(hostElement: HTMLElement): MutationObserver | null {
  const menuEmbed = hostElement.querySelector(".intiaro-menu-embed");
  const shadowRoot = (menuEmbed?.firstElementChild as any)?.shadowRoot as ShadowRoot | null;
  if (!shadowRoot) return null;

  const configuratorContainer = hostElement.querySelector(".intiaro-configurator-container");
  if (!configuratorContainer) return null;

  const observer = new MutationObserver(() => {
    const hasPanelOpen = shadowRoot.querySelector(".tab-component") !== null;
    configuratorContainer.classList.toggle("intiaro-fullscreen-panel-open", hasPanelOpen);
  });
  observer.observe(shadowRoot, { childList: true, subtree: true });
  return observer;
}
